import { useEffect, useMemo, useState } from "react";
import { useTable } from "react-table";
import primaryComponents from "../../../../primaryComponents";
import styles from "./styles.module.scss";
import secondaryComponents from "../../..";
// import { formatCurrency } from "../../../../../helpers";
// import { useGetInfo } from "../../../../../hooks/useGetInfo";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import { PlusCircle } from "../../../../../assets/svgIcons";
import { useSelector } from "react-redux";

export const useProducts = ({
  gRForm,
  setGRForm = () => {},
  ...validationParams
}) => {
  const {
    control,
    register,
    trigger,
    setValue,
    formState: { errors },
  } = validationParams;
  const [isOtherDetails, setIsOtherDetails] = useState(null);

  const { storeList } = useSelector((state) => state.profileDetailsReducer);

  const storeMap = useMemo(() => {
    return (storeList || []).reduce((acc, store) => {
      acc[store.id] = store;
      return acc;
    }, {});
  }, [storeList]);

  useEffect(() => {
    setValue("items", gRForm?.items);
  }, [gRForm?.items]);

  const columns = useMemo(
    () => [
      {
        Header: "Product Name",
        accessor: "product_name",
        Cell: ({ cell: { value }, row }) => (
          <span className="d-flex align-items-center">
            <secondaryComponents.ConcatenateWithTooltip
              value={value}
              noOfCharacters={200}
            />
          </span>
        ),
      },
      {
        Header: "Store",
        accessor: "store_id",
        Cell: ({ cell: { value } }) => storeMap[value]?.name || "N/A",
      },
      {
        Header: "Ordered Qty",
        accessor: "requested_quantity",
        Cell: ({ cell: { value } }) => (
          <span
            className={globalStyles["statusBlock--success"]}
            style={{ minWidth: "auto" }}
          >
            {value}
          </span>
        ),
      },
      {
        Header: "QTY received (Till date)",
        accessor: "total_received",
        Cell: ({ cell: { value } }) => (
          <span
            className={globalStyles["statusBlock"]}
            style={{ minWidth: "auto" }}
          >
            {value || 0}
          </span>
        ),
      },
      {
        Header: "Receive Now",
        accessor: "quantity_received",
        Cell: ({ cell: { value }, row }) => (
          <primaryComponents.InputFieldV2
            control={control}
            name={`items.${row?.index}.quantity_received`}
            register={register}
            placeholder={"Enter QTY"}
            classNames={`white ${styles.inputField}`}
            value={value}
            step={0.01}
            min={0.01}
            type="number"
            floatError={false}
            errorMessage={errors?.items?.[row?.index]?.quantity_received}
            onKeyUp={() =>
              errors?.items?.[row?.index]?.quantity_received &&
              trigger(`items.${row?.index}.quantity_received`)
            }
            onChange={({ target: { value } }) => {
              const updatedItems = [...instance?.data];
              updatedItems[row.index].quantity_received = value;

              setGRForm((prevState) => ({
                ...prevState,
                items: updatedItems,
              }));
            }}
          />
        ),
      },

      {
        Header: "Pending Qty",
        Cell: ({ row }) => {
          const quantity_short =
            Number(row?.original?.remaining_receivable || 0) +
            (Number(row?.original?.prev_quantity_received || 0) -
              Number(row?.original?.quantity_received || 0));

          return (
            <span
              className={`${quantity_short <= 0 ? globalStyles["statusBlock--success"] : globalStyles["statusBlock--failed"]}`}
              style={{ minWidth: "auto" }}
            >
              {quantity_short}
            </span>
          );
        },
      },
      {
        Header: "Expiry Date",
        accessor: "expiry_date",
        Cell: ({ cell: { value }, row }) => (
          <primaryComponents.DateInputV2
            control={control}
            name={`items.${row?.index}.expiry_date`}
            register={register}
            placeholder={"Enter expiry"}
            classNames={`white ${styles.inputField}`}
            value={value || ""}
            floatError={false}
            onChange={({ target: { value } }) => {
              const updatedItems = [...instance?.data];
              updatedItems[row.index].expiry_date = value;

              setGRForm((prevState) => ({
                ...prevState,
                items: updatedItems,
              }));
            }}
          />
        ),
      },
      {
        Header: "Other Details",
        Cell: ({ row }) => (
          <span
            className={" d-flex align-items-center cursor-pointer purple--text"}
            onClick={() =>
              setIsOtherDetails({
                product_name: row.original.product_name,
                index: row.index,
              })
            }
          >
            <PlusCircle className="mr-1" />
            <span>Add</span>
          </span>
        ),
      },
    ],
    [errors, storeMap],
  );

  const instance = useTable({
    columns,
    data: gRForm?.items || [],
  });

  return {
    instance,
    isOtherDetails,
    setIsOtherDetails,
  };
};
